import React from 'react'
import { connect } from 'react-redux'
import IconNext from 'react-icons/lib/md/keyboard-arrow-down'
import IconSkip from 'react-icons/lib/md/redo'
import { Trans } from '@lingui/react'
import {
  getNextQuestionId,
  getIsCurrentQuestionAnswered,
} from '../selectors.js'
import Button from './Button.js'

function getButtonContent(isAnswered) {
  return isAnswered ? (
    <div>
      <Trans>Next question</Trans>
      <IconNext size={24} />
    </div>
  ) : (
    <div>
      <Trans>Skip question</Trans>
      <IconSkip size={24} />
    </div>
  )
}

const NextQuestionButton = ({
  nextQuestionId,
  isAnswered,
  setCurrentQuestion,
}) => (
  <Button
    primary={isAnswered}
    iconRight
    onClick={() => setCurrentQuestion(nextQuestionId)}
    disabled={!nextQuestionId}
  >
    {getButtonContent(isAnswered)}
  </Button>
)

const mapStateToProps = state => ({
  nextQuestionId: getNextQuestionId(state),
  isAnswered: getIsCurrentQuestionAnswered(state),
})

const mapDispatchToProps = ({ currentQuestionId }) => ({
  setCurrentQuestion: questionId => currentQuestionId.set({ questionId }),
})

export default connect(mapStateToProps, mapDispatchToProps)(NextQuestionButton)



// WEBPACK FOOTER //
// ./src/components/NextQuestionButton.js